import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, DatePipe, CommonModule, PathLocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { HttpModule, } from '@angular/http';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PaginationModule } from 'ngx-bootstrap/pagination';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Import containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
  //  P404Component
]

// Import components
import {
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppHeaderNavComponent,
  AppSidebarComponent,
  AppSidebarMinimizerComponent,
  AppDescriptionComponent,
  APP_SIDEBAR_NAV,
  APP_HEADER_NAV,

} from './components';

const APP_COMPONENTS = [
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppHeaderNavComponent,
  AppSidebarComponent,
  AppSidebarMinimizerComponent,
  AppDescriptionComponent,
  APP_SIDEBAR_NAV,
  APP_HEADER_NAV
]

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,

} from './directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
]

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
//import service
import { MenuGuard } from './guard/menu.guard';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';

import {
  ApiService,
  DatetimeService,
  TreeService,
  HeThongService,
  DuAnService,
  DiemDoKhaiBaoSaiService,
  CommonService,
  TSVHService,
  TSPTService,
  ThongTinDiemDoService,
  SuKienService,
  QuyenService,
  TimKiemService,
  DongBoCmisService,
  ChiSoCongToKHService,
  DocTucThoiDiemDoService,
  DocDuLieuDCUService,
  KhaiBaoKhachHangCmisService,
  DanhMucTramService,
  DanhMucService,
  UserService,
  ThongKeChatLuongHeThongService,
  TrangThaiKetNoiRfMeshService,
  KhachHangTreoThaoService,
  ThongKeDangNhapService,
  ThongkemangtaiService,
  XuatChiSoService,
  ThongKeSanLuongService,
  ChatLuongRoutingService,
  UocTinhTonThatService,
  BanDoSoService,
  GiaoNhan110Service,
  QuanLyModemDcuService,
  canhbaovanhhanhService,
  ThietLapCanhBaoService,
  SuKienCongToService,
  CauHinhNhanService,
  CanhBaoMatDienService,
  BaocaoxulyrfgprsService,
  BaocaoloadprofileService,
  BaocaoxuchisochotthangService,
  GiamsatrepeaterService,
  BaoCaoSanLuongA0Service,
  QuanlybaocaoService,
  NhatKyVanHanhService,
  QuanlyrepeaterService,
  BaocaochatluonggprsService,
  BaoCaoLoDuongDayService,
  LaychisoService,
  ThongsochisokhachhangService,
  LaysanluongngayService,
  SosanhsanluongService,
  BaoCaoLichsuLoiService


} from './services';

const APP_SERVICE = [
  ApiService,
  DatetimeService,
  TreeService,
  HeThongService,
  DuAnService,
  DiemDoKhaiBaoSaiService,
  CommonService,
  TSVHService,
  TSPTService,
  ThongTinDiemDoService,
  SuKienService,
  QuyenService,
  TimKiemService,
  DongBoCmisService,
  ChiSoCongToKHService,
  DocTucThoiDiemDoService,
  DocDuLieuDCUService,
  KhaiBaoKhachHangCmisService,
  DanhMucTramService,
  DanhMucService,
  UserService,
  ThongKeChatLuongHeThongService,
  TrangThaiKetNoiRfMeshService,
  KhachHangTreoThaoService,
  ThongKeDangNhapService,
  ThongkemangtaiService,
  UocTinhTonThatService,
  BanDoSoService,
  GiaoNhan110Service,
  QuanLyModemDcuService,
  GiamsatrepeaterService,
  XuatChiSoService,
  canhbaovanhhanhService,
  ThietLapCanhBaoService,
  SuKienCongToService,
  CauHinhNhanService,
  CanhBaoMatDienService,
  BaocaoxulyrfgprsService,
  BaocaoxuchisochotthangService,
  BaocaoloadprofileService,
  BaoCaoSanLuongA0Service,
  QuanlybaocaoService,
  NhatKyVanHanhService,
  ChatLuongRoutingService,
  ThongKeSanLuongService,
  QuanlyrepeaterService,
  BaocaochatluonggprsService,
  BaoCaoLoDuongDayService,
  LaychisoService,
  ThongsochisokhachhangService,
  LaysanluongngayService,
  SosanhsanluongService,
  BaoCaoLichsuLoiService
];
//import { jqxModule } from '../app/share/modules/jqx.module'
import { ShareModule } from './share/modules/share.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TreeviewModule } from 'ngx-treeview';
import { ThongKeCanhBaoService } from './services/canh-bao/thong-ke-canh-bao/thongkecanhbao.service';
import { AppSidebarNavComponent, AppSidebarNavItemComponent, AppSidebarNavDropdownComponent, AppSidebarNavTitleComponent, AppSidebarNavLinkComponent } from './components/app-sidebar-nav';
import { MultidropdownComponent } from './share/multidropdown/multidropdown.component';
import { AppHeaderKhComponent } from './components/app-header-kh/app-header-kh.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    HttpModule,
    HttpClientModule,
    AutoCompleteModule,
    ModalModule.forRoot(),
    FormsModule,
    BrowserAnimationsModule,
    CalendarModule,
    ProgressBarModule,
    MultiSelectModule,
    MessageModule,
    MessagesModule,
    CommonModule,
    DropdownModule,
    NgbModule.forRoot(),
    PaginationModule.forRoot(),
    ShareModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  exports: [
    ModalModule,
    ShareModule,
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
    AppHeaderKhComponent

  ],
  providers: [{
    provide: LocationStrategy,
    //useClass: PathLocationStrategy,
    useClass: HashLocationStrategy,
  },
    APP_SERVICE,
    DatePipe
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }




// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/app.module.ts